import { BatchRecord } from 'model/batch/batchRecord';
import { IBatchRecord } from 'model/batch/iBatchTypes';
import axios from './axios';

export async function postBatchRecord(batch: BatchRecord): Promise<BatchRecord> {
  const response = await axios.post<IBatchRecord>('/v1/batch', batch);
  return new BatchRecord(response.data);
}

export async function putBatchRecord(batchId: string, batch: BatchRecord): Promise<BatchRecord> {
  const response = await axios.put<IBatchRecord>(`/v1/batch/${batchId}`, batch);
  return new BatchRecord(response.data);
}

export async function deleteBatchRecord(batchId: string): Promise<void> {
  await axios.delete(`/v1/batch/${batchId}`);
}
